import { Skeleton } from "@mui/material";
import CardContainer from "./CardContainer";

const SkeletonCard = ({
  containerClassName,
  className = "",
  span = 1,
  rows = 1,
  height = 150,
  sx,
}) => {
  return (
    <CardContainer
      sx={{ padding: "0", backgroundColor: "transparent" }}
      span={span}
      rows={rows}
      noSpan={Boolean(containerClassName)}
      className={containerClassName}
    >
      <Skeleton
        className={className}
        sx={{
          ...sx,
          width: "100%",
          transform: "scale(1)",
          height: `${height}px`,
          borderRadius: "0.5rem",
        }}
      />
    </CardContainer>
  );
};
export default SkeletonCard;
